module.exports = [{
      plugin: require('/home/circleci/zoomdata-devzone-docs/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/home/circleci/zoomdata-devzone-docs/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":786,"backgroundColor":"#ffffff"},
    },{
      plugin: require('/home/circleci/zoomdata-devzone-docs/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/circleci/zoomdata-devzone-docs/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#9D7CBF","showSpinner":false},
    },{
      plugin: require('/home/circleci/zoomdata-devzone-docs/node_modules/gatsby-plugin-glamor/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/circleci/zoomdata-devzone-docs/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/circleci/zoomdata-devzone-docs/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
